import React, { Fragment } from 'react';
import Buttons from '../button';
import {
  LoginContainer,
  LoginMain,
  LoginInfo,
  LoginTitleInfo,
  LoginTextInfo,
  LoginForm,
  LoginFormTitle,
  LoginFormText,
  LogoAligare,
  LoginInfoContent,
  ButtonBlock,
  StyleInput,
  StyledParrafo
} from './styles';
import Modal from "../modal";
import Template from "../modal/tempalte";
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from './aws-exports';

Amplify.configure(awsconfig);

class LoginComponent extends React.Component {

  constructor() {
    super();

    this.state = {
      username: '',
      pass: '',
      touched: {
        username: false,
        pass: false
      },
      errors: {
        required: {
          username: false,
          pass: false
        },
        valid: {
          pass: false,
          username: false
        }
      },
      //modal
      isOpen: false,
      modalChildren: "",
      modalResponse: "",
      isClosable: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.signIn();
  }

  handleChange(event) {
    const target = event.target;
    const { value, name } = target;
    const errors = {
      required: { ...this.state.errors.required, [name]: false }
    };
    this.setState({
      [name]: value,
      errors: { ...this.state.errors, ...errors }
    });
  }

  handleBlur(event) {
    const field = event.target.name;
    this.setState({
      touched: { ...this.state.touched, [field]: true }
    });
    this.validate(event);
  }

  validate(event) {
    const target = event.target;
    const { value, name } = target;

    if (value.length === 0) {
      const errors = {
        required: { ...this.state.errors.required, [name]: true }
      };

      this.setState({
        errors: { ...this.state.errors, ...errors }
      });
      return;
    }

    if (name === 'username') {
      this.validateUserName(value);
    }

    if (name === 'pass') {
      this.validatePass(value);
    }
  }

  validateUserName(username) {
    const isValid = true;
    const errors = {
      valid: { ...this.state.errors.valid, username: isValid }
    };

    this.setState({
      errors: { ...this.state.errors, ...errors }
    });
  }

  validatePass(pass) {
    const isValid = true;
    const errors = {
      valid: { ...this.state.errors.valid, pass: isValid }
    };

    this.setState({
      errors: { ...this.state.errors, ...errors }
    });
  }

  hasError(field) {
    return (this.state.errors.required[field] || !this.state.errors.valid[field]) && this.state.touched[field];
  }

  isFormInvalid() {
    const { pass, username, errors } = this.state;
    const { required, valid } = errors;
    const isSomeFieldRequired = Object.keys(required).some(error => required[error]);
    const isSomeFieldInvalid = Object.keys(valid).some(error => !valid[error]);

    return isSomeFieldInvalid || isSomeFieldRequired;
  }

  displayError(field) {
    const { required, valid } = this.state.errors;
    const errorMessage = 'Campo ';

    if (required[field]) {
      return `${errorMessage} requerido`;
    }

    if (!valid[field]) {
      return `${errorMessage} no válido`;
    }
  }

  render() {
    const { pass, username, errors } = this.state;
    if (localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null &&
      localStorage.getItem('perfiles') !== undefined && localStorage.getItem('perfiles') !== null) {
      if (localStorage.getItem('perfiles').includes('Admin')) {
        this.props.history.push('/home');
        return "";
      } else {
        this.props.history.push('/home/consult/estadoPago');
        return "";
      }
    } else {
      return (
        <Fragment>
          <form onSubmit={this.handleSubmit}>
            <LoginContainer>
              <LoginMain>
                <LoginInfo>
                  <LoginInfoContent>
                    <LoginTitleInfo>
                      Bienvenido
                    </LoginTitleInfo>
                    <LoginTextInfo>
                      Motor Transaccional Digital
                    </LoginTextInfo>
                  </LoginInfoContent>
                </LoginInfo>
                <LoginForm>
                  <LogoAligare src="/images/logo-aligare.png" alt="Logo Aligare" />
                  <LoginFormTitle>Mi cuenta</LoginFormTitle>
                  <LoginFormText>Ingrese su usuario</LoginFormText>
                  <StyleInput type="text"
                    value={username}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    className={this.hasError('username') ? 'error' : ''}
                    name="username" />
                  <StyledParrafo className={this.hasError('username') ? 'error-message__visible' : 'error-message'}>
                    {this.displayError('username')}
                  </StyledParrafo>
  
                  <LoginFormText>Ingrese su contraseña</LoginFormText>
                  <StyleInput type="password"
                    value={pass}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    className={this.hasError('pass') ? 'error' : ''}
                    name="pass" />
                  <StyledParrafo className={this.hasError('pass') ? 'error-message__visible' : 'error-message'}>
                    {this.displayError('pass')}
                  </StyledParrafo>
  
                  <ButtonBlock>
                    <Buttons.Primary type="submit" disabled={this.isFormInvalid()}>
                      Ingresar
                    </Buttons.Primary>
                  </ButtonBlock>
                </LoginForm>
              </LoginMain>
            </LoginContainer>
          </form>
          <Modal
            show={this.state.isOpen}
            onClose={() => {
              this.state.isClosable
                ? this.setState({
                    isOpen: !this.state.isOpen,
                  })
                : console.warn("worker on something...");
            }}
          >
            <Template name={this.state.modalChildren} response={this.state.modalResponse} />
          </Modal>
        </Fragment>
      );
    }
  }

  /**
   * Consulta usuario password. Obtiene token
   */
  authentication2 = () => {
    let endPoint = 'http://ec2-54-212-192-251.us-west-2.compute.amazonaws.com:8080/api/authenticate'
    let username = this.state.username
    let password = this.state.pass

    //limpio localstorage
    localStorage.clear();

    let requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ username, password })
    };

    fetch(endPoint, requestOptions)
      .then(result => result.json())
      .then(response => {
        if (response.token) {
          localStorage.setItem('token', response.token);
          localStorage.setItem('username', username);
          this.props.history.push('/home');
        } else {
          console.log('Aqui va el mensaje si no hay token valido')
        }
    });
  }
  
  async signIn() {
    this.setState({
      isOpen: true,
      modalChildren: "loader",
      isClosable: false
    });

    await Auth.signIn(this.state.username, this.state.pass)
    .then(user => {
      console.log('USER', user);
      localStorage.setItem('token', user.signInUserSession.accessToken.jwtToken);
      localStorage.setItem('username', user.username);
      localStorage.setItem('perfiles', user.signInUserSession.idToken.payload['cognito:groups']);
      localStorage.setItem('email', user.signInUserSession.idToken.payload['email']);
      this.setState({
        user, 
        isOpen: false,
        modalChildren: "",
        isClosable: true
      });
      if (localStorage.getItem('perfiles').includes('Admin')) {
        this.props.history.push('/home');
      } else {
        this.props.history.push('/home/consult/estadoPago');
      }
    })
    .catch(err => {
      if (!err.message) {
        console.log('Error when signing in: ', err);

        this.setState({
          isOpen: true,
          modalChildren: "error",
          modalResponse: "USUARIO O CONTRASEÑA INCORRECTOS",
          isClosable: true
        });
      } else {
        console.log('Error when signing in: ', err.message);

        this.setState({
          isOpen: true,
          modalChildren: "error",
          modalResponse: "USUARIO O CONTRASEÑA INCORRECTOS",
          isClosable: true
        });
      }
    });
  }

}

export default LoginComponent;